import { Box, Stack, Typography } from '@mui/material';

/**
 * Wordmark. The panel glyph is inline SVG so it inherits currentColor and
 * stays crisp in both colour modes without shipping two image assets.
 */
export function Logo({ compact = false }: { compact?: boolean }) {
  return (
    <Stack direction="row" spacing={1.25} alignItems="center">
      <Box
        component="svg"
        viewBox="0 0 32 32"
        aria-hidden
        sx={{ width: compact ? 26 : 30, height: compact ? 26 : 30, color: 'text.primary' }}
      >
        <circle cx="16" cy="7" r="3" fill="none" stroke="currentColor" strokeWidth="1.7" />
        <path
          d="M9 21h14l-2.3-8.5H11.3L9 21Z"
          fill="none"
          stroke="currentColor"
          strokeWidth="1.7"
          strokeLinejoin="round"
        />
        <path d="M12.7 12.5 11 21M19.3 12.5 21 21M10.2 16.8h11.6" stroke="currentColor" strokeWidth="1.1" opacity="0.55" />
      </Box>
      <Box>
        <Typography
          variant={compact ? 'h6' : 'h5'}
          component="span"
          sx={{ display: 'block', lineHeight: 1.05, letterSpacing: '-0.02em', fontWeight: 800 }}
        >
          PV Yourself
        </Typography>
        {!compact && (
          <Typography
            variant="caption"
            component="span"
            sx={{ display: 'block', color: 'text.secondary', letterSpacing: '0.12em', fontSize: 10, fontWeight: 700 }}
          >
            PLAN &amp; VOLT
          </Typography>
        )}
      </Box>
    </Stack>
  );
}
